import { GLOBAL_COLORS } from 'theme'
import { css } from 'styled-components'
import styled from 'styled-components'

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  width: 100%;
`

const TourInsert = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 825px;
`

const TourAnchor = styled.div`
  position: absolute;
  top: 0;
  height: calc(100vh - 300px);
  width: 100%;
  margin: 0 auto;
  z-index: -1;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ContentWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  & > div {
    flex-grow: 1;
  }
  ${({ theme }) => theme.mediaWidth.Mobile`
     padding-right: 0px;
  `};
  ${({ theme }) => theme.mediaWidth.Tablet`
    height: 100%;
  `}
`

const LogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 90px;
  min-width: 289px;
  border-right: 1px solid ${GLOBAL_COLORS.secondGrey05};
  ${({ theme }) => theme.mediaWidth.Desktop`
    min-width: 60px;
    height: 60px;
    justify-content: center;
  `};
  ${({ theme }) => theme.mediaWidth.Mobile`
    border-right: none;
    min-width: auto;
    justify-content: space-between;
  `}
`

const ContentContainer = styled.div<{ showFooterCTA: boolean }>`
  margin: 0 auto;
  width: fill-available;
  ${({ showFooterCTA }) =>
    !showFooterCTA &&
    css`
      max-width: 825px;
      padding: 0 85px;
    `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    width: 100%;
    padding: 0;
    margin-bottom: 0;
    > div:first-child {
      min-height: 360px;
      
    }
  `}
  ${({ theme, showFooterCTA }) => theme.mediaWidth.Tablet`
    margin: 0 auto;    
    ${() =>
      !showFooterCTA &&
      css`
        max-width: 680px;
      `}
    padding: 0;
    > div:first-child {
      min-height: 560px;
    }
  `}
`

export { ColumnWrapper, ContentWrapper, LogoWrapper, ContentContainer, TourAnchor, TourInsert }
